import React, { useEffect } from "react"
import { useTranslation } from 'react-i18next';
import { Box, Typography } from "@mui/material"
import TagButton from "../TagButton"
import { addTour } from '../../app/features/cartSlice'
import { useDispatch, useSelector } from "react-redux"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"
import { prePrareTourBookingData } from "../../utils/checkout"
import { selectTotalPrice } from '../../app/features/cartSlice';

const PaymentSummary = ({
    items,
    iva = 0,
    tour,
    extras,
    date,
    tourBooking
}) => {

    const { t } = useTranslation(['tours', 'paths', 'components']);
    const [totalPrice, setTotalPrice] = React.useState(0);
    const navigate = useNavigate();
    const currency = tour?.country?.currency || '€';

    // const selectedTotalPrice = useSelector(selectTotalPrice) || Math.ceil((totalPrice + (tour?.iva > 0 ? tour?.iva : 1 * totalPrice)));

    useEffect(() => {
        // const subTotal = items.reduce((total, item) => total + (item.price * item.value), 0);
        let totalByActivity = 0;
        const subTotal = items.reduce((total, item) => total + (item.price * item.value), 0);
        if (extras?.activities?.length > 0) {
            const paxes = tourBooking?.booking?.map(pax => ({
                name: pax.title,
                value: pax.value
            }));

            extras.activities.forEach(activity => {
                activity?.rates?.forEach(rate => {
                    const pax = items?.find(pax => pax.title === rate.pax);
                    if (pax) {
                        totalByActivity += rate.price * pax.value;
                    }
                });
            });
        }

        // Sumar el total por actividad y por item al total acumulado
        const itemTotal = subTotal + totalByActivity;
        const booking = tour?.iva > 0 ? itemTotal + Math.ceil(itemTotal * tour?.iva) : itemTotal;

        // Actualiza el totalPrice con el valor del selector
        setTotalPrice(booking);
    }, [items, tour?.country.slug, totalPrice, tourBooking]);


    const dispatch = useDispatch();


    const addToCart = () => {
        console.log('--->', tour, items);
        const tourtoBookv2 = prePrareTourBookingData(tour, date, items, {
            activities: extras?.activities
        });
        dispatch(addTour(tourtoBookv2));
        navigate('/checkout')
    }

    return (
        <Box sx={{
            backgroundColor: '#F0F0F1',
            borderRadius: "5px",
            p: "1.2rem",
        }}>
            <Typography color="secondary" variant="h5" mb={1}>
                {t('components:ordersummary')}
            </Typography>
            <>
                {items.map((item, itemIndex) => (
                    <Box
                        key={`${item.title}-${itemIndex}`}
                        sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            mb: ".5rem",
                        }}
                    >
                        <Typography
                            color="secondary"
                            sx={{ fontSize: 14, fontFamily: "inter" }}
                        >
                            {item.title}
                        </Typography>
                        <Typography
                            color="secondary"
                            sx={{ fontSize: 14, fontFamily: "inter" }}
                        >
                            {item.price * item.value} {currency}
                        </Typography>
                    </Box>
                ))}

                {
                    extras?.activities?.map((extra, extraIndex) => {
                        // Calcula el total por extra considerando los items relacionados
                        const totalExtra = extra?.rates?.reduce((total, rate) => {
                            const matchingItems = items.filter(item => rate.pax.includes(item.title));
                            const subtotal = matchingItems.reduce((sum, item) => sum + rate.price * item.value, 0);
                            return total + subtotal;
                        }, 0);

                        // Solo mostrar si el totalExtra es mayor a 0
                        return totalExtra > 0 ? (
                            <Box
                                key={`${extra.name}-${extraIndex}`}
                                sx={{
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    mb: ".5rem",
                                    pl: "1rem",
                                }}
                            >
                                <Typography
                                    color="secondary"
                                    sx={{ fontSize: 14, fontFamily: "inter" }}
                                >
                                    {extra.name}
                                </Typography>
                                <Typography
                                    color="secondary"
                                    sx={{ fontSize: 14, fontFamily: "inter" }}
                                >
                                    {totalExtra} {currency}
                                </Typography>
                            </Box>
                        ) : null;
                    })}
            </>

            <Box sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                mt: "1.5rem",
            }}
            >
                <Typography color="secondary" sx={{ lineHeight: 1 }}>
                    Total:
                </Typography>
                <Typography color="secondary" variant="h5" sx={{ lineHeight: 1 }}>
                    {totalPrice}€
                </Typography>
            </Box>
            <Typography
                color="grayText"
                sx={{
                    fontSize: 12,
                    fontFamily: "inter",
                    textAlign: "right",
                    mb: "1.5rem",
                }}
            >
                {tour?.iva > 0 ? t('IVAincluded') : ''}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <TagButton
                    text={t('components:booking-button')}
                    onClick={addToCart}
                    id='personalizar-btn'
                    sx={{
                        borderRadius: "2rem",
                        px: "1.5rem",
                        fontSize: 15,
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        lineHeight: 1.5,
                        mb: "1rem",
                        py: { xs: "1rem", md: "10px" },
                    }}
                />
            </Box>
        </Box>
    )
}

export default PaymentSummary
